import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import request from "../../../../Services/API/Requests";
import {generatingDefaultFields, getParamsFromString} from "../../Utils";
import {useSelector} from "react-redux";
import JsonScreenHoc from "../../../../HocHelpers/JsonScreenHoc";
import RenderComponents from "./RenderComponents";

const FullViewComponent = props => {
    const {component: {properties: {entity, previewMode}}, screenName} = props;
    const {globalValues} = useSelector(state => state.jsonScreen);
    const [schema, setSchema] = useState(null);
    const [generatedFields, setGeneratedFields] = useState(null);
    const isPreview = getParamsFromString(`{inParam.previewMode}`, globalValues, screenName) || previewMode;
    const entityValues = getParamsFromString(`{${entity}}`, globalValues, screenName);

    useEffect(() => {
        if (isPreview && !entityValues) return;

        if (isPreview && entityValues) {
            entity && generateFields(entity, entityValues);
            return
        }
        entity && generateFields(entity, false);
    }, [entity, JSON.stringify(entityValues), isPreview]);

    async function generateFields(entity, entityValues) {
        try {
            const res = schema ? schema : await request({
                url: 'schema/read',
                data: {id: entity}
            })
            setSchema(res)
            let tmpFields = [];
            generatingDefaultFields(
                res.properties, tmpFields, '', 0, res.id,
                true, res.properties, false, entityValues);
            setGeneratedFields(tmpFields)
        } catch (e) {
            console.log('full view entity read error', e)
        }
    }

    return (
        <div style={{
            width: '100%'
        }}>
            {generatedFields ? generatedFields.map(component => {
                return <RenderComponents
                    element={component}
                />
            }) : <></>}
        </div>
    );
};

FullViewComponent.propTypes = {
    component: PropTypes.object,
};

export default JsonScreenHoc(FullViewComponent);